import {
  section,
  mrAuto,
  mlAuto,
  title,
  container,
  description,
  cardTitle,
  coloredShadow,
  blackColor,
  whiteColor,
  grayColor,
  hexToRgb,
} from "assets/jss/material-kit-pro-react.js";

import {colors} from "../../../../../colorTheme.js"

const overviewStyle = {
  mrAuto,
  mlAuto,
  title,
  container,
  description: {
    ...description,
    marginBottom: "70px",
  },
  whiteTitle: {
    ...title, 
    color: whiteColor, 
    paddingBottom: "20px"
  },
  section: {
    ...section,
    padding: "70px 0px",
    paddingBottom: "0px"
  },
  sectionTestimonials: {
    backgroundColor:blackColor,
    paddingTop: "50px",
    paddingBottom: "80px",
    textAlign: "center",
    "& $cardTitle": {
      marginTop: "0px",
    },
  },
  features5: {
    ...section,
    backgroundRepeat: "no-repeat",
    position: "relative",
    padding: "100px 0px",
    height: "700px",
    textAlign: "center",
    "& $title": {
      zIndex: "2",
      position: "relative",
      marginBottom: "30px",
      color: whiteColor,
    },
    "& p": {
      color: whiteColor,
    },
    "&:after": {
      background: "rgba(" + hexToRgb(blackColor) + ",0.7)",
      position: "absolute",
      width: "100%",
      height: "100%",
      content: "''",
      zIndex: "0",
      left: "0px",
      top: "0px",
    },
  },
  features: {
    textAlign: "center",
    paddingTop: "30px",
    pddingBottom: "0px",
  },
  featuresShow: {
    zIndex: 3,
    border: "1px solid rgba(" + hexToRgb(whiteColor) + ",0.35)",
    borderTop: 0,
    borderBottom: 0,
    "&:last-of-type": {
      borderRight: 0,
    },
    "&:first-of-type": {
      borderLeft: 0,
    },
    "& h4,& p,& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
      color: whiteColor,
    },
    "& p": {
      lineHeight: "24px",
      fontSize: "16px",
    },
  },
  ourClients: {
    textAlign: "center",
    "& img": {
      width: "100%",
      maxWidth: "140px",
      margin: "0 auto",
      display: "inline-block",
    },
  },
  cardTitle: {
    ...cardTitle,
    marginTop: 0,
  },
  cardDescription: {
    fontSize: "16px",
    lineHeight: "1.6em",
    color: grayColor[0],
  },
  coloredShadow,
  alignLeft: {
    textAlign: "left",
  },
  statisticsCard: {
    textAlign: "left",
    display: "flex", 
    flexDirection: "column" , 
    backgroundColor: colors.bluePurpleGray,
    marginLeft: "50px",
    marginBottom: "50px",
    padding: "30px",
    height: "180px",
    color: colors.primary
  }
};

export default overviewStyle;
